// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__1_w3U","loading_body":"Loading_loading_body__1oRXW"};